// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BaseMethod } from './BaseMethod';
import { EnumAccessModifier } from '../../../../../com/MetaPattern/MDA/MD/Base/EnumAccessModifier';
import { BEEntity } from './BEEntity';
import { MethodParameter } from './MethodParameter';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 实体方法 实体类
 * 实体方法
 */
export class EntityMethod extends BaseMethod {
  /** 访问修饰符 : 访问修饰符 */
  private _accessModifier: EnumAccessModifier;

  /** 设置：访问修饰符 */
  public get accessModifier() {
    return this._accessModifier;
  }

  /** 获取：访问修饰符 */
  public set accessModifier(value: EnumAccessModifier) {
    this._accessModifier = value;
  }

  /** 是否抽象方法 : 是否抽象方法 */
  private _isAbstract: boolean;

  /** 设置：是否抽象方法 */
  public get isAbstract() {
    return this._isAbstract;
  }

  /** 获取：是否抽象方法 */
  public set isAbstract(value: boolean) {
    this._isAbstract = value;
  }

  /** 是否虚方法 : 是否是虚方法，虚方法可以被重写 */
  private _isVirtual: boolean;

  /** 设置：是否虚方法 */
  public get isVirtual() {
    return this._isVirtual;
  }

  /** 获取：是否虚方法 */
  public set isVirtual(value: boolean) {
    this._isVirtual = value;
  }

  /** 是否是静态 : 是否是静态方法 */
  private _isStatic: boolean;

  /** 设置：是否是静态 */
  public get isStatic() {
    return this._isStatic;
  }

  /** 获取：是否是静态 */
  public set isStatic(value: boolean) {
    this._isStatic = value;
  }

  /** 是否是重载方法 : 是否重载父类方法，true则会加上override关键字重写方法 */
  private _isOverride: boolean;

  /** 设置：是否是重载方法 */
  public get isOverride() {
    return this._isOverride;
  }

  /** 获取：是否是重载方法 */
  public set isOverride(value: boolean) {
    this._isOverride = value;
  }

  /** 实体 的ID */
  private _entity_ID: string;

  /** 获取：实体 的ID */
  public get entity_ID() {
    return this._entity_ID;
  }

  /** 设置：实体 的ID */
  public set entity_ID(value: string) {
    this._entity_ID = value;
  }

  /** 实体  */
  private _entity: BEEntity;

  /** 获取：实体  */
  public get entity() {
    return this._entity;
  }

  /** 设置：实体  */
  public set entity(value: BEEntity) {
    this._entity = value;
    if (value !== null) {
      this.entity_ID = value.id;
    } else {
      this.entity_ID = '';
    }
  }

  /** 参数 */
  private _parameters: Array<MethodParameter>;

  /** 获取：参数 */
  public get parameters() {
    return this._parameters;
  }

  /** 设置：参数 */
  public set parameters(value: Array<MethodParameter>) {
    this._parameters = value;
  }

  constructor() {
    super();
    this._accessModifier = EnumAccessModifier.Public;
    this._isAbstract = false;
    this._isVirtual = false;
    this._isStatic = false;
    this._isOverride = false;
    this._entity_ID = '';
    this._entity = null;
    this._parameters = new Array<MethodParameter>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: EntityMethod, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.accessModifier = element.accessModifier;
      this.isAbstract = element.isAbstract;
      this.isVirtual = element.isVirtual;
      this.isStatic = element.isStatic;
      this.isOverride = element.isOverride;
      this.entity_ID = element.entity_ID;
      if (hasReference && element.entity !== null) {
        this.entity = element.entity;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.accessModifier = json.AccessModifier as EnumAccessModifier;
    this.isAbstract = json.IsAbstract;
    this.isVirtual = json.IsVirtual;
    this.isStatic = json.IsStatic;
    this.isOverride = json.IsOverride;
    this.entity_ID = json.Entity_ID;
    // if (json.Entity !== null) {
    //   this.entity = BEEntity.Create(json.Entity);
    // }
    if (json.Parameters && json.Parameters.length > 0) {
      json.Parameters.forEach((element: any) => {
        const methodParameter = MethodParameter.Create(element);
        // methodParameter.entityMethod = this;
        this.parameters.push(methodParameter);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.AccessModifier = this.accessModifier;
    json.IsAbstract = this.isAbstract;
    json.IsVirtual = this.isVirtual;
    json.IsStatic = this.isStatic;
    json.IsOverride = this.isOverride;
    json.Entity_ID = this.entity_ID;
    if (this.parameters && this.parameters.length > 0) {
      json.Parameters = [];
      this.parameters.forEach((element) => {
        json.Parameters.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('代码属性', 'accessModifier', '访问修饰符', EnumDataType.Reference, this.accessModifier, true, '访问修饰符', 'EnumAccessModifier', 'PGRowEnumValue');
    context.addRow('代码属性', 'isAbstract', '是否抽象方法', EnumDataType.Bool, this.isAbstract, true, '是否抽象方法', '', '');
    context.addRow('代码属性', 'isVirtual', '是否虚方法', EnumDataType.Bool, this.isVirtual, true, '是否是虚方法，虚方法可以被重写', '', '');
    context.addRow('代码属性', 'isStatic', '是否是静态', EnumDataType.Bool, this.isStatic, true, '是否是静态方法', '', '');
    context.addRow('代码属性', 'isOverride', '是否是重载方法', EnumDataType.Bool, this.isOverride, true, '是否重载父类方法，true则会加上override关键字重写方法', '', '');
    return context;
  }

  static Create(json: any): EntityMethod {
    const entityMethod = new EntityMethod();
    entityMethod.Deserialize(json);
    entityMethod.json = json;
    return entityMethod;
  }
}
